import { lazy } from "react";
import { BiHome } from "react-icons/bi";
import { FiSettings } from "react-icons/fi";
import {
  LuAward,
  LuBell,
  LuClipboardList,
  LuLayoutGrid,
  LuMessageSquare,
} from "react-icons/lu";
import { PiCube, PiUsersThree } from "react-icons/pi";
import {
  TbAward,
  TbChartHistogram,
  TbTruck,
  TbUsers,
  TbUserStar,
} from "react-icons/tb";
import { GrUserSettings } from "react-icons/gr";
import WarehouseManagement from "@/pages/WarehouseManagement";
import BrandManagement from "@/pages/BrandManagement";
import AddEditInventory from "@/pages/InventoryManagement/AddEditInventory";
import CategoryManagement from "@/pages/CategoryManagement";
const InventoryDetails = lazy(() =>
  import("../pages/InventoryManagement/InventoryDetails")
);
const Login = lazy(() => import("../pages/Login"));
const SystemConfig = lazy(() => import("../pages/SystemConfig"));
const ShipmentMethod = lazy(() => import("../pages/ShipmentMethod"));
const StaffManagementDetail = lazy(() =>
  import("../pages/StaffManagementDetail")
);
const RoleManagement = lazy(() => import("../pages/RoleManagement"));
const StaffManagement = lazy(() => import("../pages/StaffManagement"));
const AddEditStaff = lazy(() => import("../pages/AddEditStaff"));
const AddEditRole = lazy(() => import("../pages/AddEditRole"));
const InventoryManagement = lazy(() => import("../pages/InventoryManagement"));
const ProfileSettings = lazy(() => import("../pages/ProfileSettings"));
const Dashboard = lazy(() => import("../pages/Dashboard"));
const UserManagement = lazy(() => import("../pages/UserManagement"));
const UserManagementDetail = lazy(() =>
  import("../pages/UserManagement/UserManagementDetail")
);
const Promotions = lazy(() => import("../pages/Promotions"));
const OrderManagement = lazy(() => import("../pages/OrderManagement"));
const OrderDetails = lazy(() =>
  import("../pages/OrderManagement/OrderDetails")
);
const RoyaltyProgram = lazy(() => import("../pages/RoyaltyProgram"));
const Notifications = lazy(() => import("../pages/Notifications"));
const ContactManagement = lazy(() => import("../pages/ContactManagement"));
const ReportsAnalytics = lazy(() => import("../pages/ReportsAnalytics"));
const Cms = lazy(() => import("../pages/Cms"));

export const routes = [
  {
    path: "/login",
    exact: true,
    protected: false,
    showInSidebar: false,
    title: "Login",
    element: <Login />,
  },
  {
    path: "/",
    exact: true,
    protected: true,
    showInSidebar: true,
    title: "Dashboard",
    element: <Dashboard />,
    icon: <BiHome />,
  },
  {
    path: "/user-management",
    exact: true,
    protected: true,
    showInSidebar: true,
    title: "User Management",
    element: <UserManagement />,
    icon: <TbUsers />,
  },
  {
    path: "/user-management/:id",
    exact: true,
    protected: true,
    showInSidebar: false,
    title: "User Management Detail",
    element: <UserManagementDetail />,
    icon: <TbUsers />,
  },
  {
    path: "/inventory-management",
    exact: true,
    protected: true,
    showInSidebar: true,
    title: "Inventory Management",
    element: <InventoryManagement />,
    icon: <PiCube />,
  },
  {
    path: "/inventory-management/:id",
    exact: true,
    protected: true,
    showInSidebar: false,
    title: "Inventory Details",
    element: <InventoryDetails />,
    icon: <PiCube />,
  },
  {
    path: "/inventory-management/edit/:id",
    exact: true,
    protected: true,
    showInSidebar: false,
    title: "Edit Inventory",
    element: <AddEditInventory />,
    icon: <PiCube />,
  },
  {
    path: "/inventory-management/add",
    exact: true,
    protected: true,
    showInSidebar: false,
    title: "Add Inventory",
    element: <AddEditInventory />,
    icon: <PiCube />,
  },
  {
    path: "/reports-analytics",
    exact: true,
    protected: true,
    showInSidebar: true,
    title: "Analytics",
    element: <ReportsAnalytics />,
    icon: <TbChartHistogram />,
  },
  {
    path: "/order-management",
    exact: true,
    protected: true,
    showInSidebar: true,
    title: "Order Management",
    element: <OrderManagement />,
    icon: <LuClipboardList />,
  },
  {
    path: "/order-management/:id",
    exact: true,
    protected: true,
    showInSidebar: false,
    title: "Order Details",
    element: <OrderDetails />,
    icon: <LuClipboardList />,
  },
  {
    path: "/royalty-program",
    exact: true,
    protected: true,
    showInSidebar: true,
    title: "Royalty Program",
    element: <RoyaltyProgram />,
    icon: <LuAward />,
  },
  {
    path: "/contact-management",
    exact: true,
    protected: true,
    showInSidebar: true,
    title: "Contact Management",
    element: <ContactManagement />,
    icon: <LuMessageSquare />,
  },
  {
    path: "/role-management",
    exact: true,
    protected: true,
    showInSidebar: true,
    title: "Role Management",
    element: <RoleManagement />,
    icon: <TbUserStar />,
  },
  {
    path: "/role-management/create",
    exact: true,
    protected: true,
    showInSidebar: false,
    element: <AddEditRole />,
  },
  {
    path: "/role-management/update/:id",
    exact: true,
    protected: true,
    showInSidebar: false,
    element: <AddEditRole />,
  },
  {
    path: "/staff-management",
    exact: true,
    protected: true,
    showInSidebar: true,
    title: "Staff Management",
    element: <StaffManagement />,
    icon: <PiUsersThree />,
  },
  {
    path: "/staff-management/create",
    exact: true,
    protected: true,
    showInSidebar: false,
    element: <AddEditStaff />,
  },
  {
    path: "/staff-management/update/:id",
    exact: true,
    protected: true,
    showInSidebar: false,
    element: <AddEditStaff />,
  },
  {
    path: "/staff-management/:id",
    exact: true,
    protected: true,
    showInSidebar: false,
    element: <StaffManagementDetail />,
  },
  {
    path: "/warehouse-management",
    exact: true,
    protected: true,
    showInSidebar: true,
    title: "Warehouse Management",
    element: <WarehouseManagement />,
    icon: <TbTruck />,
  },
  {
    path: "/brand-management",
    exact: true,
    protected: true,
    showInSidebar: true,
    title: "Brand Management",
    element: <BrandManagement />,
    icon: <LuAward />,
  },
  {
    path: "/category-management",
    exact: true,
    protected: true,
    showInSidebar: true,
    title: "Category Management",
    element: <CategoryManagement />,
    icon: <LuClipboardList />,
  },
  {
    path: "/promotions-management",
    exact: true,
    protected: true,
    showInSidebar: true,
    title: "Promotions Management",
    element: <Promotions />,
    icon: <TbAward />,
  },
  {
    path: "/cms",
    exact: true,
    protected: true,
    showInSidebar: true,
    title: "CMS",
    element: <Cms />,
    icon: <LuLayoutGrid />,
  },
  {
    path: "/system-config",
    exact: true,
    protected: true,
    showInSidebar: true,
    title: "System Config",
    element: <SystemConfig />,
    icon: <FiSettings />,
  },
  // {
  //   path: "/shipment-method",
  //   exact: true,
  //   protected: true,
  //   showInSidebar: true,
  //   title: "Shipment Method",
  //   element: <ShipmentMethod />,
  //   icon: <TbTruck />,
  // },
  {
    path: "/notifications",
    exact: true,
    protected: true,
    showInSidebar: true,
    title: "Notifications",
    element: <Notifications />,
    icon: <LuBell />,
  },
  {
    path: "/profile-settings",
    exact: true,
    protected: true,
    showInSidebar: true,
    title: "Profile Settings",
    element: <ProfileSettings />,
    icon: <GrUserSettings />,
  },
];
